import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import store from '../../../store';

class UserSeenLastTask extends AbstractRequestTask {

  constructor(group_id = "", version='v1') {
    super();
    this.group_id = group_id;
    this.version = version;

  }

  getHeaders() {
    return {};
  }

  getUrl() {

    const protocol = 'https';
    const server = Launcher.get("akamai_mfwk");
    const endpoint = 'services/user';
    const version = this.version;
    const apiname = 'seenlast';
    
    return `${protocol}://${server}/${endpoint}/${version}/${apiname}`;
  }

  getParams() {
    const params = super.getParams();
    const group_id = this.group_id;
    const user = store.getState().user;
    const lasttouch = user && user.lasttouch ? user.lasttouch.seen : false;    

    if (lasttouch) {
      params.lasttouch = lasttouch;
    }

    delete params.api_version;
    delete params.HKS;
    return Object.assign({}, params, { group_id });
  }

  success(data, b) {
    this.resolve(data);
  }
}

export default UserSeenLastTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/UserSeenLastTask.js